import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, of, shareReplay } from 'rxjs';
import { RequestService } from '../../../_services/request/request.service';
import {
  AdditionalOptions,
  CoverageLimit,
  PersonalInjuryProtectionSelection,
  GaragingSelectionType,
} from '../../../config/pip-constants';
import { ArkansasComponent } from '../arkansas/arkansas.component';
import { ColoradoComponent } from '../colorado/colorado.component';
import { DelawareComponent } from '../delaware/delaware.component';
import { DistrictOfColumbiaComponent } from '../district-of-columbia/district-of-columbia.component';
import { KansasComponent } from '../kansas/kansas.component';
import { KentuckyComponent } from '../kentucky/kentucky.component';
import { MaineComponent } from '../maine/maine.component';
import { MassachusettsComponent } from '../massachusetts/massachusetts.component';
import { MichiganComponent } from '../michigan/michigan.component';
import { NevadaComponent } from '../nevada/nevada.component';
import { Control } from '../pennsylvania/pennsylvania-model';
import { PennsylvaniaComponent } from '../pennsylvania/pennsylvania.component';
import { RhodeIslandComponent } from '../rhode-island/rhode-island.component';
import { TexasComponent } from '../texas/texas.component';
import { UtahComponent } from '../utah/utah.component';
import { WisconsinComponent } from '../wisconsin/wisconsin.component';
import { MinnesotaComponent } from '../minnesota/minnesota.component';
import { OregonComponent } from '../oregon/oregon.component';
import { NorthDakotaComponent } from '../north-dakota/north-dakota.component';
import { VirginiaComponent } from '../virginia/virginia.component';
import { FloridaComponent } from '../florida/florida.component';
import { NewYorkComponent } from '../new-york/new-york.component';
import { MarylandComponent } from '../maryland/maryland.component';
import { NewJerseyComponent } from '../new-jersey/new-jersey.component';
import { HawaiiComponent } from '../Hawaii/hawaii.component';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class PipBaseRulesService {
  states: {
    state: string;
    stateComponent: any;
    formGroup?: FormGroup;
    defaultQuery?: string;
  }[] = [
    {
      state: 'arkansas',
      stateComponent: ArkansasComponent,
      defaultQuery: 'RejectWherePermissible_Null_Null',
    },
    {
      state: 'colorado',
      stateComponent: ColoradoComponent,
      defaultQuery: 'RejectWherePermissible_Null_Null',
    },
    {
      state: 'delaware',
      stateComponent: DelawareComponent,
      defaultQuery: 'NonGarage',
    },
    {
      state: 'district-of-columbia',
      stateComponent: DistrictOfColumbiaComponent,
      defaultQuery: 'RejectWherePermissible_Null_Null',
    },
    {
      state: 'florida',
      stateComponent: FloridaComponent,
      defaultQuery: 'RejectWherePermissible_Null_Null',
    },
    {
      state: 'hawaii',
      stateComponent: HawaiiComponent,
      defaultQuery: 'RejectWherePermissible_Null_Null',
    },
    {
      state: 'kentucky',
      stateComponent: KentuckyComponent,
      defaultQuery: 'RejectWherePermissible_Null_Null',
    },
    {
      state: 'kansas',
      stateComponent: KansasComponent,
      defaultQuery: 'RejectWherePermissible_Null_Null',
    },
    {
      state: 'maine',
      stateComponent: MaineComponent,
      defaultQuery: 'NonGarage',
    },
    {
      state: 'maryland',
      stateComponent: MarylandComponent,
      defaultQuery: 'NonGarage',
    },
    {
      state: 'massachusetts',
      stateComponent: MassachusettsComponent,
      defaultQuery: 'NonGarage',
    },
    {
      state: 'michigan',
      stateComponent: MichiganComponent,
      defaultQuery: 'RejectWherePermissible_Null_Null',
    },
    {
      state: 'minnesota',
      stateComponent: MinnesotaComponent,
      defaultQuery: 'RejectWherePermissible_Null_Null',
    },
    {
      state: 'nevada',
      stateComponent: NevadaComponent,
      defaultQuery: 'RejectWherePermissible_Null_Null',
    },
    {
      state: 'new-jersey',
      stateComponent: NewJerseyComponent,
      defaultQuery: 'NonGarage',
    },
    {
      state: 'new-york',
      stateComponent: NewYorkComponent,
      defaultQuery: 'RejectWherePermissible_Null_Null',
    },
    {
      state: 'north-dakota',
      stateComponent: NorthDakotaComponent,
      defaultQuery: 'RejectWherePermissible_Null_Null',
    },
    {
      state: 'oregon',
      stateComponent: OregonComponent,
      defaultQuery: 'RejectWherePermissible_Null_Null',
    },
    {
      state: 'pennsylvania',
      stateComponent: PennsylvaniaComponent,
      defaultQuery: 'RejectWherePermissible_Null_Null',
    },
    {
      state: 'rhode-island',
      stateComponent: RhodeIslandComponent,
      defaultQuery: 'RejectWherePermissible_Null_Null',
    },
    {
      state: 'texas',
      stateComponent: TexasComponent,
      defaultQuery: 'RejectWherePermissible_Null_Null',
    },
    {
      state: 'utah',
      stateComponent: UtahComponent,
      defaultQuery: 'RejectWherePermissible_Null_Null',
    },
    {
      state: 'virginia',
      stateComponent: VirginiaComponent,
      defaultQuery: 'RejectWherePermissible_Null_Null',
    },
    {
      state: 'wisconsin',
      stateComponent: WisconsinComponent,
      defaultQuery: 'RejectWherePermissible_Null_Null',
    },
  ];

  personalInjuryProtectionSelection =
    PersonalInjuryProtectionSelection.RejectWherePermissible;
  additionalOptions = AdditionalOptions.Null;
  coverageLimit = CoverageLimit.Null;

  private saveDataSubject = new Subject<{ saveDataDump: boolean }>();
  public saveData$ = this.saveDataSubject.asObservable();
  public isPlayground: boolean = false;
  public triggerDataSave(): void {
    this.saveDataSubject.next({ saveDataDump: true });
  }

  private rulesCache = new Map<string, any>();
  dataDump = [];
  pdfDataDump = {};
  pdfSummaryDataDump = {};
  savedBaseRules = {};

  selectionTypeKey = this.getEnumKeyByValue(
    PersonalInjuryProtectionSelection,
    PersonalInjuryProtectionSelection.RejectWherePermissible,
  );
  AdditionalOptionsKey = this.getEnumKeyByValue(
    AdditionalOptions,
    AdditionalOptions.Null,
  );
  coverageLimitKey = this.getEnumKeyByValue(CoverageLimit, CoverageLimit.Null);
  garagingSelectionKey = this.getEnumKeyByValue(
    GaragingSelectionType,
    GaragingSelectionType.GaragingStateSelection,
  );
  isContinueButtonClicked = false;
  canNavigateFromSummary: () => boolean = () => true;

  constructor(
    private httpClient: HttpClient,
    private requestService: RequestService,
  ) {}
  getNonGarageStates() {
    // Return empty array if AllStateSelection, no selection
    if (
      this.garagingSelectionKey === 'AllStateSelection' ||
      !this.garagingSelectionKey ||
      this.garagingSelectionKey !== 'GaragingStateSelection'
    ) {
      return [];
    }
    // When GaragingStateSelection is chosen, calculate nonGarageStates = CoveredStates - GarageStates
    let coveredPipStates = this.requestService.getCoveredPIPStates();
    coveredPipStates = coveredPipStates.map((state: string) =>
      state.replace(/ /g, '-'),
    );

    let garagePipStates = this.requestService.getPIPGarageStates();
    garagePipStates = garagePipStates.map((state: string) =>
      state.replace(/ /g, '-'),
    );
    // Return empty array if no garage states exist
    if (!garagePipStates || garagePipStates.length === 0) {
      return [];
    }
    // Filter out garage states from covered states to get non-garage states
    const nonGarageStates = coveredPipStates.filter(
      (state) =>
        !garagePipStates.includes(state.toLowerCase().replace(/\s+/g, '-')),
    );

    return nonGarageStates;
  }

  getAllRules(state: string) {
    if (this.rulesCache.has(state)) {
      return this.rulesCache.get(state);
    }
    const textValues = this.httpClient.get<any>(
      `/assets/data/pip/states/${state}/${state}-text-values.json`,
    );
    const dynamicRules = this.httpClient.get<any>(
      `/assets/data/pip/states/${state}/${state}-dynamic-rule.json`,
    );
    const controls = this.httpClient.get<any>(
      `/assets/data/pip/states/${state}/${state}-controls.json`,
    );
    const baseRules = this.httpClient.get<any[]>(
      `/assets/data/pip/states/${state}/${state}-base-rule.json`,
    );
    const rules$ = forkJoin({
      baseRules: baseRules,
      controls: controls,
      dynamicRules: dynamicRules,
      textValues: textValues,
      state: of(state),
    }).pipe(shareReplay(1));

    this.rulesCache.set(state, rules$);
    return rules$;
  }

  getEnumKeyByValue(enumObj: any, value: string): string | undefined {
    return Object.keys(enumObj).find((key) => enumObj[key] === value);
  }
  getApplicableStates() {
    let coveredStates = this.requestService.getCoveredPIPStates();
    coveredStates = coveredStates.map((state: string) =>
      state.replace(/ /g, '-'),
    );
    let applicableStates = this.states.filter((stateObj) =>
      coveredStates.includes(stateObj.state),
    );
    return applicableStates;
  }

  getRuleBySelectionId(baseRules: any[], queryStringBuilder: string) {
    let queryString = '';
    if (queryStringBuilder === undefined) {
      queryString = this.getQueryString(baseRules);
    } else {
      queryString = queryStringBuilder;
    }
    return baseRules.find((rule) => rule.selectionId === queryString);
  }

  getNumberFromString(value: string): number {
    const numericString = value.split('/')[0].replace(/[^0-9.-]+/g, '');
    return parseFloat(numericString);
  }
  getQueryString(res: any): string {
    const baseQueryCount = res[0].selectionId.split('_').length;
    switch (baseQueryCount) {
      case 1:
        return `${this.selectionTypeKey}`;
      case 2:
        return `${this.selectionTypeKey}_${this.AdditionalOptionsKey}`;
      case 3:
        return `${this.selectionTypeKey}_${this.AdditionalOptionsKey}_${this.coverageLimitKey}`;
      default:
        break;
    }
  }
  getValueOfFormControls(value: any) {
    if ('selectedIndex' in value) {
      return value['value'];
    } else if ('isSelected' in value) {
      return value['name'];
    } else {
      ('');
    }
  }

  initialPDFDataDumpProp(controls: Control[], state: string) {
    let pdfObj = {};
    controls.forEach((control) => {
      if (control.formControlName.toLocaleLowerCase().includes('_checkbox')) {
        pdfObj = {
          ...pdfObj,
          ...{ [control.formControlName.toLocaleLowerCase()]: false },
        };
      } else if (
        control.formControlName.toLocaleLowerCase().includes('_radio')
      ) {
        control?.option?.forEach((option) => {
          pdfObj[option.baseRuleKey.toLocaleLowerCase()] = false;
        });
      } else if (
        control.baseRuleKey.toLocaleLowerCase().includes('_dropdown')
      ) {
        control.data.forEach((data) => {
          pdfObj[
            control.baseRuleKey.toLocaleLowerCase().split('dropdown')[0] +
              this.stripDropDownValue(data.name)
          ] = false;
        });
      }
    });
    // hack for summary page data dump
    // this.pdfDataDump[state] = {
    //   ...pdfObj,
    // };
    this.pdfDataDump[state] = {
      ...pdfObj,
      ...{
        namedInsured: this.requestService.getNamedInsured(),
        initials: this.requestService.getInitials(),
        policyNumber: this.requestService.getPolicyNumberForState(state),
        liabilityLimit: this.requestService.getLiabilityLimitForState(state),
        personalInjuryProtectionSelection:
          this.personalInjuryProtectionSelection,
        additionalOptions: this.additionalOptions,
        coverageLimit: this.coverageLimit,
      },
    };
  }
  setReadOnlyDynamicRulesForPDFDump(state: string) {
    const pdfObj = {};
    Array.from(document.querySelectorAll('[id]'))
      .filter((ele) => ele.id.includes('-pdffield-' + state))
      .map((ele) => ele.id.split('-pdffield-' + state)[0])
      .forEach((id) => {
        pdfObj[id] = true;
      });
    this.pdfDataDump[state] = {
      ...this.pdfDataDump[state],
      ...pdfObj,
    };
  }

  getPdfDataDumpPropForOutstandingPage(state: string, formData: any) {
    this.setReadOnlyDynamicRulesForPDFDump(state);

    let pdfObj = {};
    for (const [key, value] of Object.entries(formData)) {
      if (key.toLocaleLowerCase().includes('_checkbox')) {
        pdfObj = {
          ...pdfObj,
          ...{ [key.toLocaleLowerCase()]: value },
        };
      } else if ((value as string).toLowerCase().includes('_radio')) {
        pdfObj = {
          ...pdfObj,
          ...{ [(value as string).toLocaleLowerCase()]: true },
        };
      }
      if (key.toLocaleLowerCase().includes('_dropdown')) {
        pdfObj = {
          ...pdfObj,
          ...{
            [key.toLocaleLowerCase().split('dropdown')[0] +
            this.stripDropDownValue(value)]: true,
          },
        };
      }
      if (key.toLocaleLowerCase().includes('_input')) {
        pdfObj = {
          ...pdfObj,
          ...{ [key.toLocaleLowerCase()]: value },
        };
      }
    }
    this.pdfDataDump[state] = {
      ...this.pdfDataDump[state],
      ...pdfObj,
    };
  }

  isStatePageEmpty(containerElement?: Element): boolean {
    // Use specific container or document to check if all <app-state> components are empty
    const searchRoot = containerElement || document;
    const stateSelectors = this.states.map(
      (s) => `app-${s.state.replace(/_/g, '-').replace(/ /g, '-')}`,
    );
    for (const selector of stateSelectors) {
      const elements = Array.from(searchRoot.querySelectorAll(selector));
      for (const el of elements) {
        if (el.hasChildNodes() && el.childNodes.length > 0) {
          if (el.childNodes.length > 2) {
            return false;
          }
        }
      }
    }
    return true;
  }

  private stripDropDownValue(value: unknown) {
    let str = (value as string)
      .replaceAll('$', '')
      .replaceAll('%', '')
      .replace(/,000,000/g, 'M')
      .replace(/,000/g, 'k')
      .replace(/ /g, '_')
      .replaceAll('/', '_')
      .replaceAll(',', '');

    // Enhance: convert 1500k to 1_5M, 2500k to 2_5M, etc. anywhere in the string
    str = str.replace(/(\d{4,})k/g, (match, p1) => {
      const num = parseInt(p1, 10);
      const whole = Math.floor(num / 1000);
      const decimal = num % 1000 ? Math.round((num % 1000) / 100) : 0;
      return decimal ? `${whole}_${decimal}M` : `${whole}M`;
    });
    return str;
  }

  getPdfDataDumpPropForSummaryPage(baseRules: any, state: string) {
    let pdfObj = {};

    if (baseRules && !baseRules.hasOutstanding) {
      for (const [key, value] of Object.entries(baseRules)) {
        if (key.toLowerCase().includes('_radio') && value === 'Yes') {
          pdfObj = { ...pdfObj, ...{ [key.toLocaleLowerCase()]: true } };
        } else if (key.toLocaleLowerCase().includes('_dropdown')) {
          if (
            this.pdfDataDump &&
            state in this.pdfDataDump &&
            this.pdfDataDump[state] &&
            Object.keys(this.pdfDataDump[state]).length > 0
          ) {
            if (value !== 'hide' && value !== 'form') {
              pdfObj[
                Object.keys(this.pdfDataDump[state]).find(
                  (obj) =>
                    obj
                      .toLocaleLowerCase()
                      .includes(
                        key.toLocaleLowerCase().split('_dropdown')[0],
                      ) && !obj.includes('radio'),
                )
              ] = true;
            }
          }
        } else if (key.toLowerCase().includes('_checkbox') && value === 'Yes') {
          pdfObj = { ...pdfObj, ...{ [key.toLocaleLowerCase()]: true } };
        }
        this.pdfDataDump[state] = {
          ...this.pdfDataDump[state],
          ...pdfObj,
        };
      }
    }
    this.pdfSummaryDataDump = { ...this.pdfDataDump };
  }
}
